import { Injectable } from '@angular/core';
import { DataTableFilter } from '../../shared-module/common/models/DataTableFilter.model';
import { IPagedDataTable } from '../../shared-module/common/interfaces/IPagedDataTable.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ProductTableRow } from './product-data-table-row.model';
import { IDataTableService } from '../../shared-module/common/interfaces/IDataTableService.interface';
import { UrlPrefix } from "../../shared-module/common/constants/url-prefix.constants";
import { KeyValuePair } from "../../shared-module/common/models/KeyValuePair.model";
import { ProductTranslationExportRequest } from '../../import-export-module/bulk-import-export-product-translations/product-translations-export.model';

@Injectable()
export class ProductsDataTableService implements IDataTableService<ProductTableRow> {

  constructor(private http: HttpClient) {
  }

  public getRows(filter: DataTableFilter, params?: Array<KeyValuePair<string, number>>): Observable<IPagedDataTable<ProductTableRow>> {
    let queryString = '';
    if(params && params.length > 0){
       queryString = `&${params.map(p => `${p.key}=${p.value}`).join('&')}`;
    }
    return this.http.get<IPagedDataTable<ProductTableRow>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/products?${filter.toQueryString()}${queryString}`);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/products/${id}`);
  }
  
  public exportProductTranslations(exportRequest: ProductTranslationExportRequest, filter: DataTableFilter): Observable<number> {
    return this.http.post<number>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/productTranslationImportExport/export?${filter.toODataQueryString()}`, exportRequest);
  }

  public exportProducts(filter: DataTableFilter, emailMeWhenDone: boolean): Observable<string> {
    return this.http.post<string>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/products/export?${filter.toQueryString()}`, emailMeWhenDone);
  }
}
